import { render, staticRenderFns } from "./addresstag.vue?vue&type=template&id=d6e0ffac&scoped=true"
var script = {}
import style0 from "./addresstag.vue?vue&type=style&index=0&id=d6e0ffac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e0ffac",
  null
  
)

export default component.exports